// resources/js/Helpers/BookingReturn.js
import { DateTime } from "luxon";
import { bookableDays } from "../Composables/useBookingSchedule.js";

/**
 * The slot a signed-out visitor picked, written into the URL they sign in from. It has to travel
 * in the address rather than in memory, because logging in is a full page navigation and takes
 * every ref on this page with it.
 */
export const bookingReturnPath = ({ space, day, hour }) => {
    if (!space || !day || hour === null || hour === undefined) {
        return "/";
    }

    const query = new URLSearchParams({
        space: space.id,
        date: day.toFormat("yyyy-MM-dd"),
        hour: hour,
    });

    return `/?${query.toString()}`;
};

/**
 * Reads one back. The URL has been through the address bar and a login round trip by now, so it
 * is somebody else's input: anything the calendar would not itself have offered is refused rather
 * than reopened.
 */
export const bookingReturnSlot = (search) => {
    const params = new URLSearchParams(search || "");
    const space = params.get("space");
    const date = params.get("date");
    const hour = params.get("hour");

    if (space === null || date === null || hour === null) {
        return null;
    }

    const spaceId = Number(space);
    const startHour = Number(hour);

    if (!Number.isInteger(spaceId) || !Number.isInteger(startHour) || startHour < 0 || startHour > 23) {
        return null;
    }

    const day = DateTime.fromFormat(date, "yyyy-MM-dd");

    if (!day.isValid || !bookableDays().some((candidate) => candidate.hasSame(day, "day"))) {
        return null;
    }

    return { spaceId: spaceId, day: day, hour: startHour };
};
